module.exports = __webpack_public_path__ + "media/images/emblems/Yverdon-Les-Bains-coat_of_arms-4eebac4729e3493f6ef31b9760ce5520.svg";